// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2SIML","header":"PatientQuestionnaire_header__8folW","info":"PatientQuestionnaire_info__1tWqI"};